import { CompanySettings } from '$models'

/**
 * Holds the settings object getActiveCompanySettings() builds for the active
 * company. Building it reads every preference one at a time, and the formatting
 * helpers ask for it on each render, so a grid of dates and currency would
 * rebuild the same object hundreds of times.
 *
 * appContext clears it whenever the app context changes.
 *
 * It sits in its own module so appContext can clear it without importing
 * helpers, which pulls in the app store and cycles back to appContext.
 */
let cachedCompanySettings: {
  companyId: string | undefined
  settings: CompanySettings
} | null = null

export const readCachedCompanySettings = (
  companyId: string | undefined
): CompanySettings | null =>
  cachedCompanySettings?.companyId === companyId
    ? cachedCompanySettings?.settings ?? null
    : null

export const writeCachedCompanySettings = (
  companyId: string | undefined,
  settings: CompanySettings
): void => {
  cachedCompanySettings = { companyId, settings }
}

export const clearCompanySettingsCache = (): void => {
  cachedCompanySettings = null
}
